module.exports = __webpack_public_path__ + "static/storage-base-6-a888585d7489512db26259dbffd13cbd.webp";